// lib/googleMapsConfig.ts
// Centralized Google Maps config for Off Axis Deals

// IMPORTANT:
// - process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is only reliable at build time.
// - To avoid "missing" issues in the browser, we hardcode a fallback.
// - Replace the placeholder string with the real key from Vercel.

const FALLBACK_GOOGLE_MAPS_API_KEY = 'AIzaSyB_yYy5rip-5cSAtND5G_VvPIAq7VmPvAg';

export const GOOGLE_MAPS_API_KEY: string =
  process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY && process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY.trim().length > 0
    ? process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
    : FALLBACK_GOOGLE_MAPS_API_KEY;

if (!GOOGLE_MAPS_API_KEY || GOOGLE_MAPS_API_KEY === 'REPLACE_WITH_REAL_BROWSER_MAPS_KEY') {
  // We do NOT want noisy logs in production anymore – just a one-time warning.
  if (typeof window !== 'undefined') {
    console.warn('[OffAxis] Google Maps API key fallback in use. Update lib/googleMapsConfig.ts');
  }
}

export const GOOGLE_MAPS_ID = 'dealflow-google-map';

export const GOOGLE_MAPS_LIBRARIES: ('drawing' | 'places' | 'visualization')[] = [
  'drawing',
  'places',
  'visualization',
];

/**
 * Shared loader configuration for useJsApiLoader
 * 
 * The googleMapsApiKey value is passed to @react-google-maps/api's Loader,
 * which constructs the script URL as:
 * https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=drawing,places,visualization
 */
export const googleMapsLoaderConfig = {
  id: GOOGLE_MAPS_ID,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
  preventGoogleFontsLoading: true,
} as const;

/**
 * Check if Google Maps API is already loaded
 * 
 * Use this before calling the loader to avoid redundant loads.
 */
export function isGoogleMapsLoaded(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!(
    window.google &&
    window.google.maps &&
    window.google.maps.Map
  );
}
